import { Card, CardContent, EmptyState, PageHeader, StatusChip } from "@jod/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Table2 } from "lucide-react";
import { useMemo } from "react";
import { useStaffState } from "../../features/ops/queries.ts";

export const Route = createFileRoute("/_app/tables")({ component: TablesScreen });

function TablesScreen() {
  const navigate = useNavigate();
  const { data } = useStaffState();
  const grouped = useMemo(
    () =>
      data?.zones.map((zone) => ({
        zone,
        tables: data.tables.filter((table) => table.zoneId === zone.id),
      })) ?? [],
    [data],
  );
  return (
    <div className="space-y-6">
      <PageHeader
        title="Active tables / โต๊ะ"
        subtitle="Zone grouping, occupancy, social-active indicator, and force-clear workflow."
      />
      {!data ? (
        <EmptyState icon={<Table2 />} title="Loading tables" description="Fetching floor state…" />
      ) : (
        grouped.map(({ zone, tables }) => (
          <section key={zone.id} className="space-y-3">
            <h2 className="font-display font-semibold text-lg">
              {zone.name} / {zone.nameTh}
            </h2>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-4">
              {tables.map((table) => (
                <Card key={table.id}>
                  <CardContent className="space-y-3 p-4">
                    <div className="flex items-start justify-between gap-3">
                      <button
                        type="button"
                        className="font-semibold text-left"
                        onClick={() =>
                          navigate({
                            to: "/tables/$tableSessionId",
                            params: { tableSessionId: table.id },
                          })
                        }
                      >
                        {table.label}
                        <br />
                        <span className="text-muted-foreground text-xs">
                          {table.code} · cap {table.capacity}
                        </span>
                      </button>
                      <StatusChip
                        tone={
                          table.status === "occupied"
                            ? "warning"
                            : table.status === "free"
                              ? "success"
                              : table.status === "pending"
                                ? "info"
                                : "neutral"
                        }
                      >
                        {table.status}
                      </StatusChip>
                    </div>
                    <p className="text-sm">Party size {table.partySize}</p>
                    <div className="flex gap-2">
                      {table.socialActive ? (
                        <StatusChip tone="info">social active</StatusChip>
                      ) : (
                        <StatusChip tone="neutral">order-only/private</StatusChip>
                      )}
                      {table.orderOnly ? <StatusChip tone="neutral">non-social</StatusChip> : null}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
}
